const getCampaigns = (value, category, callback) => {
  const requestInit = {
    method: 'GET',
    credentials: 'same-origin',
  };

  fetch(`/campaigns/categories/${category}/search?term=${value}`, requestInit)
    .then((response) => response.json())
    .then((response) => response.results)
    .then(callback);
};

export default getCampaigns;
